class CollectionHeader extends HTMLElement {
    constructor() {
        super();
        this.expandBtn = this.querySelector('[data-expand]')
    }



    connectedCallback() {
        function isEllipsisActive(e) {
            return (e.offsetWidth < e.scrollWidth);
        }
        const textContainer = this.querySelector('[data-description]')

        if (textContainer.scrollHeight > textContainer.clientHeight) {
            this.expandBtn.classList.remove('tw-hidden')
        }

        this.expandBtn?.addEventListener('click', this.handleExpand.bind(this))
    }

    handleExpand() {
        this.classList.toggle('collapseDescription', !this.classList.contains('collapseDescription'))
    }

}

customElements.define('collection-header', CollectionHeader);
